/* eslint-disable */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { ModalRoute } from 'react-router-modal';
import './bookingDetailsStrikesWidget.scss';
import * as api from '../../../../epics/api';

import history from '../../../../history';

const propTypes = {
    job: PropTypes.object.isRequired,
    notification: PropTypes.object.isRequired,
    table: PropTypes.object.isRequired,
};

const strikeReasons = [
    {
        label: 'No Show',
        value: 'NO_SHOW',
    },

    {
        label: 'Late by more than one hour',
        value: 'VERY_LATE',
    },

    {
        label: 'Late to the shift, but gave notice',
        value: 'LATE_WITH_NOTICE',
    },

    {
        label: 'Late to the shift, did not give notice',
        value: 'LATE_WITHOUT_NOTICE',
    },

    {
        label: 'Cancelled shift less than 48 hours before start',
        value: 'CANCELLED',
    },

    {
        label: 'Cancelled shift less than 24 hours before start',
        value: 'CANCELLED_24_HOURS',
    },

    {
        label: 'Cancelled shift less than 4 hours before start',
        value: 'CANCELLED_4_HOURS',
    },

    {
        label: 'Unprofessional behaviour',
        value: 'UNPROFESSIONAL_BEHAVIOUR',
    },

    {
        label: 'Wrong equipment or uniform',
        value: 'WRONG_EQUIPMENT',
    },

    {
        label: 'Average rating score is below minimum threshold',
        value: 'BELOW_AVERAGE_RATING_SCORE',
    },

    {
        label: 'Zero strikes postponing cooldown',
        value: 'SOFT_STRIKE',
    },
];

class BookingDetailsStrikes extends Component {
    constructor() {
        super();
        this.state = {
            strikes: { meta: null, content: [] },
            addStrikes: [],
            isPosting: false,
        };
    }

    closeModal = () => {
        const pathname = this.props.location.pathname.replace('/strikes/', '/');
        history.push(pathname + this.props.location.search);
    };

    componentDidMount() {
        this.fetchStrikes();
    }

    isPosting(status = true) {
        this.setState({ isPosting: status });
    }

    fetchStrikes = () =>
        api
            .executeHttpRequest(
                `jobs/${this.props.relevantJobId}/bookings/${this.props.job.booking.id}/strikes/`,
            )
            .then(res => {
                this.setState({
                    strikes: { meta: res.data.meta, content: res.data.content },
                });
            });

    addStrikeRow = () =>
        this.setState({
            addStrikes: [
                ...this.state.addStrikes,
                {
                    id: 1,
                    reason: 'NO_SHOW',
                    comment: '',
                },
            ],
        });

    handleRemoveExistingStrikeRow = idx => {
        this.setState({
            addStrikes: this.state.addStrikes.filter(
                (addStrikeRow, addStrikeRowIndex) => idx !== addStrikeRowIndex,
            ),
        });
    };

    handleAddStrikeFieldChange = (idx, fieldName) => evt => {
        const newAddStrikes = this.state.addStrikes.map((addStrike, sidx) => {
            if (idx !== sidx) return addStrike;
            if (fieldName == 'comment') {
                return { ...addStrike, comment: evt.target.value };
            }
            return { ...addStrike, reason: evt.target.value };
        });

        this.setState({ addStrikes: newAddStrikes });
    };

    handleAddStrikeSave = () => {
        const postData = this.state.addStrikes.map(addStrike => ({
            ...addStrike,
        }));
        this.isPosting(true);

        return api
            .executeHttpRequest(
                `jobs/${this.props.relevantJobId}/bookings/${this.props.job.booking.id}/strikes/`,
                'post',
                postData,
            )
            .then(res => {
                this.isPosting(false);
                this.fetchStrikes().then(() => {
                    this.resetAddStrikes();
                    this.props.table.table.fireFetchData();
                });
            });
    };

    handleRemoveExistingStrike = strike => {
        this.isPosting(true);

        return api
            .executeHttpRequest(
                `jobs/${this.props.relevantJobId}/bookings/${this.props.job.booking.id}/strikes/${strike.id}/`,
                'delete',
            )
            .then(res => {
                this.isPosting(false);
                this.fetchStrikes();
                this.props.table.table.fireFetchData();
            });
    };

    resetAddStrikes = () => {
        this.setState({ addStrikes: [] });
    };

    renderExistingStrikesRow() {
        return this.state.strikes.content.map(strike => {
            const reason = strike.reason
                .replace('_', ' ')
                .replace(
                    /\w\S*/g,
                    txt =>
                        txt.charAt(0).toUpperCase() +
                        txt.substr(1).toLowerCase(),
                );
            return (
                <tr key={`strike-${strike.id}`}>
                    <td>{reason}</td>
                    <td>{strike.comment}</td>
                    <td className="actions center">
                        <button
                            onClick={() =>
                                this.handleRemoveExistingStrike(strike)
                            }
                        >
                            <i className="icon icon-bin-1 cursor-pointer" />
                        </button>
                    </td>
                </tr>
            );
        });
    }

    renderAddStrikesRow() {
        return this.state.addStrikes.map((addStrike, index) => (
            <tr key={`add-strike-${index}`}>
                <td>
                    <select
                        value={addStrike.reason}
                        onChange={this.handleAddStrikeFieldChange(
                            index,
                            'reason',
                        )}
                    >
                        {strikeReasons.map((strikeReason, index) => (
                            <option key={index} value={strikeReason.value}>
                                {strikeReason.label}
                            </option>
                        ))}
                    </select>
                </td>
                <td>
                    <textarea
                        className="comment"
                        value={addStrike.comment}
                        onChange={this.handleAddStrikeFieldChange(
                            index,
                            'comment',
                        )}
                    />
                </td>

                <td className="actions center">
                    <button
                        onClick={() =>
                            this.handleRemoveExistingStrikeRow(index)
                        }
                    >
                        <i className="icon icon-close cursor-pointer" />
                    </button>
                </td>
            </tr>
        ));
    }

    render() {
        return (
            <div className="booking-details booking-details-strikes-modal">
                <div className="header-section">
                    <div className="title">
                        Strikes for {this.props.job.booking.reference_number}
                    </div>
                    <div
                        className="header-dismiss"
                        onClick={() => this.closeModal()}
                    >
                        <i className="icon icon-close" />
                    </div>
                </div>
                <div className="content-section">
                    <table className="table-default">
                        <tbody>
                            <tr>
                                <td className="table-default__cell--text-blue">
                                    Reason
                                </td>
                                <td className="table-default__cell--text-blue">
                                    Comment
                                </td>
                                <td className="table-default__cell--text-blue actions center" />
                            </tr>
                            {this.renderExistingStrikesRow()}
                            {this.renderAddStrikesRow()}
                        </tbody>
                    </table>
                    <div className="add-row">
                        <i className="icon icon-add-12" />
                        <span
                            className="margin-5-px"
                            onClick={() => this.addStrikeRow()}
                        >
                            Add another strike
                        </span>
                    </div>
                    <div className="btns">
                        {this.state.isPosting ? (
                            <i className="icon icon-loading-1" />
                        ) : null}
                        <button
                            className={this.state.isPosting ? 'disabled' : ''}
                            onClick={() => this.handleAddStrikeSave()}
                        >
                            SAVE
                        </button>
                    </div>
                </div>
            </div>
        );
    }
}

BookingDetailsStrikes.propTypes = propTypes;

export default BookingDetailsStrikes;
